<template>
  <div class="raffle_detail_container">
    <div class="back">
      <span class="back-arrow" @click="$router.back(-1)">
        <Icon iconClass="arrow-left2" />
      </span>
      <span v-text="raffleTitle" class="page_title"></span>
    </div>
    <div class="raffle_detail_box" v-if="!!detail">
      <shake :freeFlag="params.freeFlag" :awards="awards" :detailInfo="detail" v-if="params.type==1"></shake>
      <scrape :freeFlag="params.freeFlag" :awards="awards" :detailInfo="detail" v-else-if="params.type==2"></scrape>
      <turntable :freeFlag="params.freeFlag" :awards="awards" :detailInfo="detail" v-else-if="params.type==3"></turntable>
      <smasheggs :freeFlag="params.freeFlag" :awards="awards" :detailInfo="detail" v-else-if="params.type==4"></smasheggs>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import raffleApi from "@/api/apis/raffle.js";
import commApi from "@/api/apis/common.js";
import shake from "./components/Shake"; // 摇摇乐
import scrape from "./components/Scrape"; // 刮刮乐
import turntable from "./components/Turntable"; // 大转盘
import smasheggs from "./components/SmashEggs"; // 砸金蛋
export default {
  name: "RaffleDetail",
  data() {
    return {
      raffleTitle: "抽奖",
      params: {
        contentType: 2,
        freeFlag: 0, // 是否赠送的抽奖
        drawRaffleId: 0,
        type: 0
      },
      detail: null, // 抽奖详情
      awards: [], // 奖项
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  components: {
    shake,
    scrape,
    turntable,
    smasheggs,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/raffle_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "抽奖", _this.detail.raffleName, _this.shareUrl, _this.detail.bigResourceUrl);
      }).catch((err) => {

      })
    },
    /* 获取抽奖详情 */
    getDrawRaffleById() {
      var _this = this;
      var params = {
        id: _this.params.drawRaffleId,
        memberId: _this.userInfo.id,
        sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
      }
      raffleApi
        .findOneDrawRaffleById(params)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.raffleName;
            _this.detail = res.data;
            _this.raffleTitle = res.data.raffleName;
            if (_this.params.type == 0) {
              _this.params.type = _this.detail.raffleForm;
            }
            _this.wechatShare(); // 微信二次分享
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取奖项设置 */
    getAwardListById() {
      var _this = this;
      raffleApi
        .listAwardByDrawRaffleId({ drawRaffleId: _this.params.drawRaffleId })
        .then((res) => {
          if (res.suc == 1) {
            _this.awards = res.data.awards;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    let query = this.$route.query;
    if (!!this.userInfo) {
      if (Object.prototype.hasOwnProperty.call(query, "drawRaffleId")) {
        this.params.contentType = Number(query.contentType) || 2;
        this.params.freeFlag = Number(query.freeFlag) || 0;
        this.params.drawRaffleId = Number(query.drawRaffleId);
        this.params.type = Number(query.type) || 0;
        this.getDrawRaffleById();
        this.getAwardListById();
        loadStat(); // 友盟统计
      } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
        this.params.contentType = Number(query.contentType) || 2;
        this.params.freeFlag = Number(query.freeFlag) || 0;
        this.params.drawRaffleId = Number(query.contentId);
        this.params.type = Number(query.type) || 0;
        this.getDrawRaffleById();
        this.getAwardListById();
        loadStat(); // 友盟统计
      } else {
        this.$router.replace({
          path: "/error",
        });
        return;
      }
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
<style scoped lang="scss">
.raffle_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background-color: #df3435;
  overflow: hidden;
  .back {
    background-color: #df3435;
    border-color: #df3435;
    color: #fff;
    .back-arrow {
      color: #fff;
      .tj-svg-icon {
        color: #fff;
      }
    }
    .page_title {
      display: block;
      max-width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: auto;
    }
  }
  .raffle_detail_box {
    width: 100%;
    height: calc(100% - 43px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>